



// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Container,
//   Box,
//   Typography,
//   Paper,
//   Divider,
//   Button,
//   Avatar,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   TextField,
//   Grid,
//   Tooltip,
//   CircularProgress,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Card,
//   CardContent,
//   Alert,
//   Snackbar,
// } from "@mui/material";
// import {
//   ArrowBack,
//   Print,
//   Download,
//   LocalHospital,
//   Person,
//   Receipt,
//   Phone,
//   Email,
//   Language,
//   Home,
//   CalendarToday,
//   Male,
//   Female,
//   ReceiptLong,
//   ContentCopy,
// } from "@mui/icons-material";
// import { styled } from "@mui/material/styles";
// import logo from "../assets/saloonlogo.png";
// import html2pdf from "html2pdf.js";
// import { NumericFormat } from 'react-number-format';
// import qz from "qz-tray";
// import SendIcon from '@mui/icons-material/Send';



// const PRINTER_NAME = "BIXOLON SRP-E302"; // Change to your thermal printer name

// // Enhanced Cash drawer commands for thermal printers
// const CASH_DRAWER_COMMANDS = {
//   OPEN_DRAWER_PIN2: "\x1B\x70\x00\x19\xFA",
//   OPEN_DRAWER_PIN5: "\x1B\x70\x01\x19\xFA",
//   ALTERNATE_1: "\x1B\x70\x00\x60\x60",
//   ALTERNATE_2: "\x1B\x70\x01\x60\x60",
//   BELL_COMMAND: "\x07",
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(4),
//   marginTop: theme.spacing(3),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
//   maxWidth: 1500,
//   margin: "0 auto",
//   "@media print": {
//     boxShadow: "none",
//     padding: theme.spacing(3),
//     border: "1px solid #ddd",
//   },
// }));

// const HeaderBox = styled(Box)(({ theme }) => ({
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   marginBottom: theme.spacing(4),
//   "@media (max-width: 600px)": {
//     flexDirection: "column",
//     gap: theme.spacing(2),
//     alignItems: "flex-start",
//   },
//   "@media print": {
//     flexDirection: "row",
//     alignItems: "center",
//   },
// }));

// const TotalRow = styled(TableRow)(({ theme }) => ({
//   backgroundColor: theme.palette.grey[100],
//   "& td": {
//     fontWeight: "bold",
//     fontSize: "1.1rem",
//   },
// }));

// const DiscountRow = styled(TableRow)(({ theme }) => ({
//   backgroundColor: theme.palette.grey[50],
//   "& td": {
//     padding: theme.spacing(2),
//   },
// }));

// const InvoiceNumberBox = styled(Box)(({ theme }) => ({
//   backgroundColor: theme.palette.secondary.main,
//   color: 'white',
//   padding: '6px 12px',
//   borderRadius: '16px',
//   display: 'inline-block',
//   marginTop: theme.spacing(1),
//   fontSize: '0.875rem',
//   fontWeight: 500,
//   '-webkit-print-color-adjust': 'exact',
//   'color-adjust': 'exact',
//   'print-color-adjust': 'exact',
// }));




// // QZ Tray Thermal Printing Component
// const QZTrayThermalPrint = ({ 
//   open, 
//   onClose, 
//   patients, 
//   invoicedetails, 
//   treatmentamount, 
//   discount, 
//   discountType, 
//   calculateSubtotal, 
//   calculateTotalAmount 
// }) => {
//   const [printStatus, setPrintStatus] = useState({ open: false, message: '', severity: 'info' });
//   const [isPrinting, setIsPrinting] = useState(false);
//   const [isOpeningDrawer, setIsOpeningDrawer] = useState(false);
  
   

//   const showMessage = (message, severity = 'info') => {
//     setPrintStatus({ open: true, message, severity });
//   };

//   // Thermal printer formatting constants
//   const esc = "\x1B";
//   const gs = "\x1D";
//   const LINE_WIDTH = 48; // 80mm thermal printer width

//   const leftRight = (left, right, width = LINE_WIDTH) => {
//     const space = width - (left.length + right.length);
//     return left + " ".repeat(space > 0 ? space : 1) + right;
//   };

//   const centerText = (text, width = LINE_WIDTH) => {
//     const padding = Math.max(0, Math.floor((width - text.length) / 2));
//     return " ".repeat(padding) + text;
//   };

//   const divider = (char = "-") => char.repeat(LINE_WIDTH) + "\n";

//   const formatCurrency = (value) => {
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(Number(value));
//   };


  

//   // Enhanced Cash Drawer Function
//   const openCashDrawer = async () => {
//     try {
//       console.log("Attempting to open cash drawer...");
      
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
      
//       const config = qz.configs.create(PRINTER_NAME);
      
//       // Try different cash drawer commands in sequence
//       const commands = [
//         CASH_DRAWER_COMMANDS.OPEN_DRAWER_PIN2,
//         CASH_DRAWER_COMMANDS.OPEN_DRAWER_PIN5,
//         CASH_DRAWER_COMMANDS.ALTERNATE_1,
//         CASH_DRAWER_COMMANDS.ALTERNATE_2,
//         CASH_DRAWER_COMMANDS.BELL_COMMAND
//       ];
      
//       let drawerOpened = false;
//       let lastError = null;
      
//       for (const command of commands) {
//         try {
//           console.log(`Trying cash drawer command: ${Array.from(command).map(c => c.charCodeAt(0))}`);
//           await qz.print(config, [{ type: "raw", format: "command", data: command }]);
//           console.log("Cash drawer command sent successfully");
//           drawerOpened = true;
//           break;
//         } catch (error) {
//           console.warn(`Cash drawer command failed: ${error.message}`);
//           lastError = error;
//         }
//       }
      
//       if (!drawerOpened) {
//         console.error("All cash drawer commands failed", lastError);
//         throw new Error(`Cash drawer failed to open: ${lastError?.message || 'Unknown error'}`);
//       }
      
//       return drawerOpened;
//     } catch (error) {
//       console.error("Cash drawer error:", error);
//       throw error;
//     }
//   };

//   // Generate thermal receipt commands for QZ Tray
//  const generateThermalReceipt = () => {
//   const subtotal = Number(calculateSubtotal()) + Number(treatmentamount);
//   const totalAmount = Number(calculateTotalAmount());
  
//   // Function to wrap long text into multiple lines
//   const wrapText = (text, maxLength = 24) => {
//     if (text.length <= maxLength) return [text];
    
//     const words = text.split(' ');
//     const lines = [];
//     let currentLine = '';
    
//     for (const word of words) {
//       if ((currentLine + word).length <= maxLength) {
//         currentLine += (currentLine ? ' ' : '') + word;
//       } else {
//         if (currentLine) lines.push(currentLine);
//         // If a single word is longer than maxLength, break it
//         if (word.length > maxLength) {
//           for (let i = 0; i < word.length; i += maxLength) {
//             lines.push(word.substring(i, i + maxLength));
//           }
//           currentLine = '';
//         } else {
//           currentLine = word;
//         }
//       }
//     }
    
//     if (currentLine) lines.push(currentLine);
//     return lines;
//   };

//   const lines = [
//     esc + "@", // Initialize printer
    
//     // Company header - Center aligned and emphasized
//     esc + "a" + "\x01", // Center align
//     esc + "!" + "\x38", // Double height and emphasized
//     "Beauty Bliss\n",
//     esc + "!" + "\x00", // Cancel text formatting
    
//     // Company details
//     esc + "!" + "\x08", // Emphasized
//     "No:128/1,Pahala karagahamuna,Kadawatha.\n",
//     "Tel: 0114532108 | 0117905805\n",
//     "Email: akdldhshana@gmail.com\n",
//     esc + "!" + "\x00", // Cancel emphasis
    
//     divider("="),
    
//     // Receipt title
//     esc + "!" + "\x12", // Medium size
//     esc + "a" + "\x01", // Center align
//     esc + "!" + "\x28", // Double height and emphasized
//     "PAYMENT RECEIPT\n",
//     esc + "!" + "\x00", // Cancel size
//     divider("="),
    
//     // Invoice info
//     leftRight("Invoice:", invoicedetails?.MTD_SERIAL_NO || 'N/A') + "\n",
//     leftRight("Date:", new Date().toLocaleDateString('en-GB')) + "\n",
//     leftRight("Time:", new Date().toLocaleTimeString('en-GB', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     })) + "\n",
    
//     divider("-"),
//     esc + "a" + "\x01" + "PATIENT DETAILS" + "\n" + esc + "a" + "\x00",
//     divider("-"),
    
//     // Patient details - Left aligned
//     `Name: ${patients?.MPD_PATIENT_NAME || 'N/A'}\n`,
//     `Address: ${(patients?.MPD_ADDRESS || 'Not specified').substring(0, 30)}\n`,
//     `Gender/Age: ${patients?.MPD_GENDER || 'N/A'}/${
//       patients?.MPD_BIRTHDAY ? 
//       new Date().getFullYear() - new Date(patients.MPD_BIRTHDAY).getFullYear() : 'N/A'
//     }\n`,
    
//     divider("-"),
//     centerText("BILLING DETAILS") + "\n",
//     divider("-"),
    
//     // Items header
//     esc + "!" + "\x08", // Emphasized
//     leftRight("Item", "Qty  Price   Amount") + "\n",
//     esc + "!" + "\x00", // Cancel emphasis
//     divider("-"),
//   ];

//   // Add medicine items with text wrapping for long names
//   if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
//     invoicedetails.Drugs.forEach(medicinedetail => {
//       const medicineName = medicinedetail.MMC_MATERIAL_SPEC || medicinedetail.DrugName;
//       const wrappedLines = wrapText(medicineName, 24); // Increased to 24 characters
      
//       const qty = medicinedetail.MDD_QUANTITY.toString().padStart(2);
//       const rate = formatCurrency(medicinedetail.MDD_RATE).padStart(6);
//       const amount = formatCurrency(medicinedetail.MDD_AMOUNT).padStart(8);
      
//       // First line with medicine name and amount
//       lines.push(leftRight(wrappedLines[0], `${qty}  ${rate} ${amount}`) + "\n");
      
//       // Additional lines for wrapped text (without amount)
//       for (let i = 1; i < wrappedLines.length; i++) {
//         lines.push(wrappedLines[i] + "\n");
//       }
//     });
//   } else {
//     lines.push(centerText("No medications") + "\n");
//   }

//   // Add totals
//   lines.push(
//     divider("-"),
//     ...(invoicedetails?.Drugs?.length > 0 ? [
//       leftRight("Drug Subtotal:", `Rs. ${formatCurrency(calculateSubtotal())}`) + "\n"
//     ] : []),
//     leftRight("Treatment Fee:", `Rs. ${formatCurrency(treatmentamount)}`) + "\n",
//     leftRight("Subtotal:", `Rs. ${formatCurrency(subtotal)}`) + "\n",
//     ...(discount > 0 ? [
//       leftRight(
//         "Discount:", 
//         discountType === 'percentage' ? 
//         `-${discount}%` : 
//         `-Rs. ${formatCurrency(discount)}`
//       ) + "\n"
//     ] : []),
//     divider("="),
//     esc + "!" + "\x18", // Medium size
//     leftRight("TOTAL:", `Rs. ${formatCurrency(totalAmount)}`) + "\n",
//     esc + "!" + "\x00", // Cancel size
//     divider("="),
//     "\n",
//     centerText("THANK YOU!") + "\n",
//     centerText("Beauty Bliss") + "\n",
//     divider("*"),
//     centerText(new Date().toLocaleString('en-GB')) + "\n",
//     "\n\n\n\n\n", // Extra lines for paper cut
//     gs + "V" + "\x41" + "\x03" // Cut paper
//   );

//   return lines.join("");
// };

//   const printThermalReceipt = async () => {
//     if (isPrinting) return;
    
//     setIsPrinting(true);
    
//     try {
//       // Connect to printer first
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
//       const config = qz.configs.create(PRINTER_NAME);

//       const printData = generateThermalReceipt();

//       // Print the receipt
//       console.log("Printing thermal receipt...");
//       await qz.print(config, [{ type: "raw", format: "command", data: printData }]);
//       console.log("Thermal receipt printed successfully");

//       showMessage('Thermal receipt printed successfully!', 'success');
//       onClose();
//     } catch (err) {
//       console.error("Print process failed:", err);
//       showMessage("Print error: " + err.message, 'error');
//     } finally {
//       setIsPrinting(false);
//     }
//   };

//   // Separate function to just open cash drawer
//   const handleOpenCashDrawer = async () => {
//     if (isOpeningDrawer) return;
    
//     setIsOpeningDrawer(true);
//     try {
//       await openCashDrawer();
//       showMessage("Cash drawer opened successfully!", 'success');
//     } catch (error) {
//       console.error("Cash drawer error:", error);
//       showMessage("Error opening cash drawer: " + error.message, 'error');
//     } finally {
//       setIsOpeningDrawer(false);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" alignItems="center" gap={1}>
//             <ReceiptLong color="primary" />
//             QZ Tray Thermal Printing
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//             Direct printing to thermal printer using QZ Tray
//           </Typography>
          
//           <Card variant="outlined" sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Receipt Preview (Thermal Format)
//               </Typography>
//               <Paper 
//                 variant="outlined" 
//                 sx={{ 
//                   p: 2, 
//                   backgroundColor: '#f5f5f5', 
//                   fontFamily: 'Courier New, monospace', 
//                   fontSize: '12px', 
//                   lineHeight: '1.2', 
//                   whiteSpace: 'pre',
//                   maxHeight: '400px',
//                   overflow: 'auto',
//                   border: '1px dashed #ccc'
//                 }}
//               >
//                 {generateThermalReceipt().replace(/\x1B\[.*?m/g, '')} {/* Remove escape sequences for preview */}
//               </Paper>
//             </CardContent>
//           </Card>

//           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
//             <Button 
//               variant="outlined" 
//               onClick={handleOpenCashDrawer}
//               disabled={isOpeningDrawer}
//               startIcon={<Receipt />}
//             >
//               {isOpeningDrawer ? "Opening..." : "Test Cash Drawer"}
//             </Button>
//             <Typography variant="body2" color="text.secondary">
//               Printer: {PRINTER_NAME}
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={onClose}>Cancel</Button>
//           <Button 
//             onClick={printThermalReceipt} 
//             variant="contained" 
//             color="primary"
//             startIcon={<Print />}
//             disabled={isPrinting}
//           >
//             {isPrinting ? "Printing..." : "Print Thermal Receipt"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar 
//         open={printStatus.open} 
//         autoHideDuration={6000} 
//         onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           severity={printStatus.severity} 
//           onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         >
//           {printStatus.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// // Main Invoice Component
// export default function Invoice() {
//   const { patientId, serial_no } = useParams();
//   const [patients, setPatients] = useState(null);
//   const [invoicedetails, setInvoicedetails] = useState(null);
//   const [treatmentamount, setTreatmentamount] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [discountType, setDiscountType] = useState("percentage");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [qzTrayDialogOpen, setQzTrayDialogOpen] = useState(false);
//   const navigate = useNavigate();


//   const [smsLoading, setSmsLoading] = useState(false);
//   const [smsStatus, setSmsStatus] = useState({ open: false, message: '', severity: 'info' });

//   // const sendSmsBill = async () => {
//   //   if (!patients || !invoicedetails) return;

//   //   setSmsLoading(true);

//   //   try {
//   //     // Construct message content
//   //     const totalAmount = calculateTotalAmount();
//   //     const message = `Dear ${patients.MPD_PATIENT_NAME}, your invoice ${invoicedetails.MTD_SERIAL_NO} amount is Rs ${totalAmount}. Thank you for visiting Beauty Bliss.`;

//   //     // API request
//   //     const response = await axios.post(
//   //       `${process.env.REACT_APP_API_BASE_URL}/Appointment/send-Invoice-messages`,
//   //       {
//   //         Message: message,
//   //         Contacts: [patients.MPD_MOBILE_NO] // replace with the actual field of phone number
//   //       }
//   //     );

//   //     console.log("SMS Response:", response.data);
//   //     setSmsStatus({ open: true, message: 'SMS sent successfully!', severity: 'success' });
//   //   } catch (error) {
//   //     console.error("SMS Error:", error);
//   //     setSmsStatus({ open: true, message: 'Failed to send SMS', severity: 'error' });
//   //   } finally {
//   //     setSmsLoading(false);
//   //   }
//   // };


//   const sendSmsBill = async () => {
//   if (!patients || !invoicedetails) return;

//   setSmsLoading(true);

//   try {
//     const totalAmount = calculateTotalAmount();
//     const subtotal = Number(calculateSubtotal()) + Number(treatmentamount);
    
//     // Build product details
//     let productDetails = "";
    
//     if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
//       invoicedetails.Drugs.forEach((item) => {
//         const itemName = item.MMC_MATERIAL_SPEC || item.DrugName || "Item";
//         const amount = item.MDD_AMOUNT ? new Intl.NumberFormat('en-US', {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//         }).format(Number(item.MDD_AMOUNT)) : "0.00";
        
//         productDetails += `${itemName}: Rs. ${amount}\n`;
//       });
//     }

//     // Add treatment charges if applicable
//     let treatmentSection = "";
//     if (treatmentamount && Number(treatmentamount) > 0) {
//       treatmentSection = `Treatment Charges: Rs. ${new Intl.NumberFormat('en-US', {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//       }).format(Number(treatmentamount))}\n`;
//     }

//     // Calculate discount amount properly
//     const discountAmount = discountType === 'percentage' 
//       ? (subtotal * discount / 100)
//       : Number(discount);

//     // Format all amounts with commas (thousands separators)
//     const formatWithCommas = (value) => {
//       return new Intl.NumberFormat('en-US', {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//       }).format(Number(value));
//     };

//     const formattedSubtotal = formatWithCommas(subtotal);
//     const formattedDiscount = formatWithCommas(discountAmount);
//     const formattedTotal = formatWithCommas(totalAmount);

//     // Construct the exact message format you want
//     const message = `${productDetails}${treatmentSection}Subtotal: Rs. ${formattedSubtotal}
// Discount: Rs. ${formattedDiscount}
// Balance Due: Rs. ${formattedTotal}

// Thank you for choosing BeautyBliss!
// Please arrange the payment at your earliest convenience.`;

//     console.log("SMS Message:", message); // For debugging

//     // API request
//     const response = await axios.post(
//       `${process.env.REACT_APP_API_BASE_URL}/Appointment/send-Invoice-messages`,
//       {
//         Message: message,
//         Contacts: [patients.MPD_MOBILE_NO]
//       }
//     );

//     console.log("SMS Response:", response.data);
    
//     if (response.data && response.data.success > 0) {
//       setSmsStatus({ 
//         open: true, 
//         message: `SMS bill sent successfully to ${response.data.success} contact(s)!`, 
//         severity: 'success' 
//       });
//     } else {
//       setSmsStatus({ 
//         open: true, 
//         message: 'SMS sending completed but no successful deliveries', 
//         severity: 'warning' 
//       });
//     }
    
//   } catch (error) {
//     console.error("SMS Error:", error);
//     let errorMessage = 'Failed to send SMS bill';
    
//     if (error.response?.data) {
//       errorMessage = error.response.data;
//     } else if (error.message) {
//       errorMessage = error.message;
//     }
    
//     setSmsStatus({ 
//       open: true, 
//       message: errorMessage, 
//       severity: 'error' 
//     });
//   } finally {
//     setSmsLoading(false);
//   }
// };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const [treatmentRes, patientRes] = await Promise.all([
//           axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
//           ),
//           axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
//           ),
//         ]);
//         setInvoicedetails(treatmentRes.data);
//         setTreatmentamount(treatmentRes.data.MTD_AMOUNT || 0);
//         setPatients(patientRes.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setError(error.response?.data?.message || "Failed to fetch data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [patientId, serial_no]);

//   const calculateSubtotal = () => {
//     if (invoicedetails && invoicedetails.Drugs) {
//       const total = invoicedetails.Drugs.reduce(
//         (total, drug) => total + drug.MDD_AMOUNT,
//         0
//       );
//       return total.toFixed(2);
//     }
//     return 0;
//   };

//   const calculateTotalAmount = () => {
//     const subtotal =
//       parseFloat(calculateSubtotal()) + parseFloat(treatmentamount);
//     let totalAmount = subtotal;

//     if (discountType === "percentage") {
//       totalAmount -= (subtotal * discount) / 100;
//     } else {
//       totalAmount -= discount;
//     }

//     return totalAmount.toFixed(2);
//   };

//   const printInvoice = () => {
//     const noPrintElements = document.querySelectorAll('.no-print');
//     noPrintElements.forEach(element => {
//       element.style.display = 'none';
//     });

//     const printStyles = document.createElement('style');
//     printStyles.innerHTML = `
//     @media print {
//       body * {
//         visibility: hidden;
//       }
      
//       #invoice-content, #invoice-content * {
//         visibility: visible;
//       }
      
//       #invoice-content {
//         position: absolute;
//         left: 0;
//         top: 0;
//         width: 100%;
//       }
      
//       .MuiContainer-root {
//         max-width: none !important;
//         padding: 0 !important;
//         margin: 0 !important;
//       }
      
//       .MuiPaper-root {
//         box-shadow: none !important;
//         border: none !important;
//         margin: 0 !important;
//         padding: 20px !important;
//       }
      
//       @page {
//         size: A4;
//         margin: 15mm;
//       }
//     }
//   `;

//     document.head.appendChild(printStyles);
//     window.print();

//     setTimeout(() => {
//       document.head.removeChild(printStyles);
//       noPrintElements.forEach(element => {
//         element.style.display = '';
//       });
//     }, 100);
//   };

//   const downloadInvoice = () => {
//     const element = document.getElementById("invoice-content");
//     const opt = {
//       margin: [10, 10, 10, 10],
//       filename: `invoice_${patientId}_${serial_no}.pdf`,
//       image: {
//         type: "jpeg",
//         quality: 0.98
//       },
//       html2canvas: {
//         scale: 2,
//         logging: false,
//         useCORS: true,
//         allowTaint: true,
//         backgroundColor: '#ffffff',
//         ignoreElements: function (element) {
//           return element.classList.contains('no-print');
//         }
//       },
//       jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "portrait",
//         putOnlyUsedFonts: true,
//         floatPrecision: 16
//       },
//       pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
//     };
//     const tempStyles = document.createElement('style');
//     tempStyles.innerHTML = `
//       .invoice-number-pdf {
//         backgroundColor: theme.palette.secondary.main;
//         color: white !important;
//         -webkit-print-color-adjust: exact !important;
//         color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//     `;
//     document.head.appendChild(tempStyles);

//     html2pdf().set(opt).from(element).save().then(() => {
//       document.head.removeChild(tempStyles);
//     });
//   };

//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="80vh"
//       >
//         <CircularProgress size={60} />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//           <Typography variant="h6" color="error">
//             {error}
//           </Typography>
//           <Button
//             variant="contained"
//             color="primary"
//             sx={{ mt: 2 }}
//             onClick={() => window.location.reload()}
//           >
//             Retry
//           </Button>
//         </Paper>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="xl" sx={{ py: 4 }}>
//       <Box sx={{ mb: 3 }} className="no-print">
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={() => navigate(-1)}
//           variant="outlined"
//         >
//           Back to Records
//         </Button>
//       </Box>

//       <StyledPaper elevation={3} id="invoice-content">
//         <HeaderBox>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Avatar
//               src={logo}
//               alt="Medicare Logo"
//               variant="rounded"
//               sx={{ width: 80, height: 80, '@media print': { width: 60, height: 60 } }}
//             />
//             <Box>


//               <Typography variant="h5" fontWeight="bold" color="primary" sx={{ '@media print': { fontSize: '2rem' } }}>
//                 BEAUTY BLISS
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 202/A, Mandawala Road,Malamulla,Panadura.
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 Tel: 076 380 9974
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 Web: www.beautyblissbyprima.com
//               </Typography>
//             </Box>
//           </Box>

//           <Box sx={{ textAlign: "right" }}>
//             <Typography variant="h5" color="primary" fontWeight="bold" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//               Payment Receipt
//             </Typography>
//             <InvoiceNumberBox className="invoice-number-pdf">
//               Invoice - {invoicedetails?.MTD_SERIAL_NO || "N/A"}
//             </InvoiceNumberBox>
//           </Box>
//         </HeaderBox>

//         <Divider sx={{ my: 3 }} />

//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: { xs: 2, sm: 3 },
//             mb: 4,
//             alignItems: "center",
//             justifyContent: "space-between",
//             '& > *': {
//               flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 24px)', md: '1 1 calc(25% - 24px)' },
//               minWidth: { xs: '100%', sm: '200px' },
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//             },
//             '@media print': {
//               gap: 2,
//               marginBottom: '16px',
//               '& > *': {
//                 flex: '1 1 calc(25% - 16px)',
//                 minWidth: 'auto'
//               }
//             }
//           }}
//         >
//           <Box>
//             <Person color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Customer Name
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {patients?.MPD_PATIENT_NAME}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <Home color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Address
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{
//                 '@media print': { fontSize: '1rem' },
//                 display: '-webkit-box',
//                 WebkitLineClamp: 1,
//                 WebkitBoxOrient: 'vertical',
//                 overflow: 'hidden'
//               }}>
//                 {patients?.MPD_ADDRESS || "Not specified"}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <CalendarToday color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Date
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {new Date().toLocaleDateString()}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             {patients?.MPD_GENDER === "Male" ? (
//               <Male color="primary" />
//             ) : (
//               <Female color="primary" />
//             )}
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Gender / Age
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {patients?.MPD_GENDER} /{" "}
//                 {patients?.MPD_BIRTHDAY
//                   ? new Date().getFullYear() -
//                   new Date(patients.MPD_BIRTHDAY).getFullYear()
//                   : "N/A"}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         <TableContainer
//           component={Paper}
//           elevation={0}
//           sx={{ border: "1px solid #eee", mb: 4 }}
//         >
//           <Table>
//             <TableHead sx={{ backgroundColor: "primary.main" }}>
//               <TableRow>
//                 <TableCell sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}>
//                  Products and Treatments
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Rate (Rs)
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Quantity
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Amount (Rs)
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {invoicedetails?.Drugs?.map((medicinedetail, index) => (
//                 <TableRow key={index} hover>
//                   <TableCell sx={{ '@media print': { fontSize: '0.9rem' } }}>{medicinedetail.DrugName}</TableCell>
//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_RATE
//                       ? new Intl.NumberFormat('en-US', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       }).format(Number(medicinedetail.MDD_RATE))
//                       : "0.00"}
//                   </TableCell>

//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_QUANTITY
//                       ? new Intl.NumberFormat('en-US').format(Number(medicinedetail.MDD_QUANTITY))
//                       : "0"}
//                   </TableCell>

//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_AMOUNT
//                       ? new Intl.NumberFormat('en-US', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       }).format(Number(medicinedetail.MDD_AMOUNT))
//                       : "0.00"}
//                   </TableCell>
//                 </TableRow>
//               ))}

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ fontWeight: 'normal','@media print': { fontSize: '0.9rem' } }}>
//                   Total Treatment Fee:
//                 </TableCell>
//                 <TableCell align="right" sx={{ fontWeight: 'normal','@media print': { fontSize: '0.9rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(Number(calculateSubtotal()))}
//                 </TableCell>
//               </TotalRow>

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ fontWeight: 'normal','@media print': { fontSize: '0.9rem' } }}>
//                   Treatment Fee:
//                 </TableCell>
//                 <TableCell align="right" sx={{ fontWeight: 'normal','@media print': { fontSize: '0.9rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(Number(treatmentamount))}
//                 </TableCell>
//               </TotalRow>

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ fontWeight: 'normal','@media print': { fontSize: '0.9rem' } }}>
//                   Subtotal:
//                 </TableCell>
//                 <TableCell align="right" sx={{ fontWeight: 'normal','@media print': { fontSize: '0.9rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(
//                     Number(calculateSubtotal()) + Number(treatmentamount)
//                   )}
//                 </TableCell>
//               </TotalRow>

//               <DiscountRow>
//                 <TableCell colSpan={1}></TableCell>
//                 <TableCell>
//                   <Typography fontWeight="bold" sx={{ '@media print': { fontSize: '1rem' } }}>Discount</Typography>
//                   <RadioGroup
//                     row
//                     value={discountType}
//                     onChange={(e) => setDiscountType(e.target.value)}
//                     sx={{ mt: 1 }}
//                   >
//                     <FormControlLabel
//                       value="percentage"
//                       control={<Radio size="small" />}
//                       label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Percentage</Typography>}
//                     />
//                     <FormControlLabel
//                       value="fixed"
//                       control={<Radio size="small" />}
//                       label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Fixed Amount</Typography>}
//                     />
//                   </RadioGroup>
//                 </TableCell>
//                 <TableCell align="right">
//                   <TextField
//                     type="number"
//                     size="small"
//                     value={discount}
//                     onChange={(e) => setDiscount(e.target.value)}
//                     inputProps={{
//                       min: "0",
//                       max:
//                         discountType === "percentage"
//                           ? "100"
//                           : parseFloat(calculateSubtotal()) +
//                           parseFloat(treatmentamount),
//                     }}
//                     sx={{ width: 120 }}
//                   />
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   {discountType === "percentage"
//                     ? `${discount}%`
//                     : `Rs: ${discount}`}
//                 </TableCell>
//               </DiscountRow>

//               <TotalRow sx={{ backgroundColor: "primary.light" }}>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}>
//                   <Typography variant="h6">Final Amount:</Typography>
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}
//                 >
//                   <Typography variant="h6">
//                     Rs: {new Intl.NumberFormat('en-US', {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2
//                     }).format(Number(calculateTotalAmount()))}
//                   </Typography>
//                 </TableCell>
//               </TotalRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Box
//           sx={{
//             mt: 6,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "flex-end",
//           }}
//         >
//           <Box
//             sx={{
//               width: 300,
//               textAlign: "center",
//               p: 2,
//             }}
//           >
//             <Divider sx={{ mb: 2 }} />
//             <Typography variant="body1" color="text.secondary" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//               Authorized Signature
//             </Typography>
//             <Typography variant="h6" fontWeight="bold" sx={{ mt: 2, '@media print': { fontSize: '1.1rem' } }}>
//              Beauty Bliss
//             </Typography>
//           </Box>
//         </Box>
//       </StyledPaper>

//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           gap: 3,
//           mt: 4,
//           "@media print": {
//             display: "none",
//           },
//         }}
//         className="no-print"
//       >
//         <Tooltip title="Print standard invoice">
//           <Button
//             variant="contained"
//             color="primary"
//             startIcon={<Print />}
//             onClick={printInvoice}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Print Invoice
//           </Button>
//         </Tooltip>
//          <Tooltip title="Send Invoice via SMS">
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={<SendIcon />}
//               onClick={sendSmsBill}
//               sx={{ px: 4, py: 1.5 }}
//               disabled={smsLoading}
//             >
//               {smsLoading ? "Sending..." : "SMS Bill"}
//             </Button>
//           </Tooltip>

//         <Tooltip title="Print thermal receipt via QZ Tray">
//           <Button
//             variant="contained"
//             color="secondary"
//             startIcon={<ReceiptLong />}
//             onClick={() => setQzTrayDialogOpen(true)}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             QZ Tray Print
//           </Button>
//         </Tooltip>

//         <Tooltip title="Download as PDF">
//           <Button
//             variant="outlined"
//             color="primary"
//             startIcon={<Download />}
//             onClick={downloadInvoice}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Download PDF
//           </Button>
//         </Tooltip>
//       </Box>

//     <Snackbar
//       open={smsStatus.open}
//       autoHideDuration={6000}
//       onClose={() => setSmsStatus({ ...smsStatus, open: false })}
//       anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//     >
//       <Alert
//         severity={smsStatus.severity}
//         onClose={() => setSmsStatus({ ...smsStatus, open: false })}
//         sx={{ width: "100%" }}
//       >
//         {smsStatus.message}
//       </Alert>
//     </Snackbar>

//       {/* QZ Tray Thermal Printing Dialog */}
//       <QZTrayThermalPrint
//         open={qzTrayDialogOpen}
//         onClose={() => setQzTrayDialogOpen(false)}
//         patients={patients}
//         invoicedetails={invoicedetails}
//         treatmentamount={treatmentamount}
//         discount={discount}
//         discountType={discountType}
//         calculateSubtotal={calculateSubtotal}
//         calculateTotalAmount={calculateTotalAmount}
//       />
//     </Container>
//   );
// }


// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Container,
//   Box,
//   Typography,
//   Paper,
//   Divider,
//   Button,
//   Avatar,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   TextField,
//   Grid,
//   Tooltip,
//   CircularProgress,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Card,
//   CardContent,
//   Alert,
//   Snackbar,
// } from "@mui/material";
// import {
//   ArrowBack,
//   Print,
//   Download,
//   LocalHospital,
//   Person,
//   Receipt,
//   Phone,
//   Email,
//   Language,
//   Home,
//   CalendarToday,
//   Male,
//   Female,
//   ReceiptLong,
//   ContentCopy,
// } from "@mui/icons-material";
// import { styled } from "@mui/material/styles";
// import logo from "../assets/saloonlogo.png";
// import html2pdf from "html2pdf.js";
// import { NumericFormat } from 'react-number-format';
// import qz from "qz-tray";
// import SendIcon from '@mui/icons-material/Send';



// const PRINTER_NAME = "BIXOLON SRP-E302"; // Change to your thermal printer name

// // Enhanced Cash drawer commands for thermal printers
// const CASH_DRAWER_COMMANDS = {
//   OPEN_DRAWER_PIN2: "\x1B\x70\x00\x19\xFA",
//   OPEN_DRAWER_PIN5: "\x1B\x70\x01\x19\xFA",
//   ALTERNATE_1: "\x1B\x70\x00\x60\x60",
//   ALTERNATE_2: "\x1B\x70\x01\x60\x60",
//   BELL_COMMAND: "\x07",
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(4),
//   marginTop: theme.spacing(3),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
//   maxWidth: 1500,
//   margin: "0 auto",
//   "@media print": {
//     boxShadow: "none",
//     padding: theme.spacing(3),
//     border: "1px solid #ddd",
//   },
// }));

// const HeaderBox = styled(Box)(({ theme }) => ({
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   marginBottom: theme.spacing(4),
//   "@media (max-width: 600px)": {
//     flexDirection: "column",
//     gap: theme.spacing(2),
//     alignItems: "flex-start",
//   },
//   "@media print": {
//     flexDirection: "row",
//     alignItems: "center",
//   },
// }));

// const TotalRow = styled(TableRow)(({ theme }) => ({
//   backgroundColor: theme.palette.grey[100],
//   "& td": {
//     fontWeight: "bold",
//     fontSize: "0.9rem",
//   },
// }));

// const DiscountRow = styled(TableRow)(({ theme }) => ({
//   backgroundColor: theme.palette.grey[50],
//   "& td": {
//     padding: theme.spacing(2),
//   },
// }));

// // const InvoiceNumberBox = styled(Box)(({ theme }) => ({
// //   backgroundColor: theme.palette.secondary.main,
// //   color: 'white',
// //   padding: '6px 12px',
// //   borderRadius: '16px',
// //   display: 'inline-block',
// //   marginTop: theme.spacing(1),
// //   fontSize: '0.875rem',
// //   fontWeight: 500,
// //   '-webkit-print-color-adjust': 'exact',
// //   'color-adjust': 'exact',
// //   'print-color-adjust': 'exact',
// // }));

// const InvoiceNumberBox = styled(Box)(({ theme }) => ({
//   backgroundColor: theme.palette.secondary.main,
//   color: theme.palette.common.white,
//   padding: theme.spacing(0.75, 2),
//   borderRadius: theme.shape.borderRadius * 2,
//   display: "inline-flex",
//   alignItems: "center",
//   fontSize: "0.9rem",
//   fontWeight: 600,
//   letterSpacing: "0.3px",
//   marginTop: theme.spacing(1.2),
//   boxShadow: "0 2px 6px rgba(0,0,0,0.15)",

//   // Print adjustments
//   printColorAdjust: "exact",
//   WebkitPrintColorAdjust: "exact",
// }));




// // QZ Tray Thermal Printing Component
// const QZTrayThermalPrint = ({ 
//   open, 
//   onClose, 
//   patients, 
//   invoicedetails, 
//   treatmentamount, 
//   discount, 
//   discountType, 
//   calculateSubtotal, 
//   calculateTotalAmount 
// }) => {
//   const [printStatus, setPrintStatus] = useState({ open: false, message: '', severity: 'info' });
//   const [isPrinting, setIsPrinting] = useState(false);
//   const [isOpeningDrawer, setIsOpeningDrawer] = useState(false);
  
   

//   const showMessage = (message, severity = 'info') => {
//     setPrintStatus({ open: true, message, severity });
//   };

//   // Thermal printer formatting constants
//   const esc = "\x1B";
//   const gs = "\x1D";
//   const LINE_WIDTH = 48; // 80mm thermal printer width

//   const leftRight = (left, right, width = LINE_WIDTH) => {
//     const space = width - (left.length + right.length);
//     return left + " ".repeat(space > 0 ? space : 1) + right;
//   };

//   const centerText = (text, width = LINE_WIDTH) => {
//     const padding = Math.max(0, Math.floor((width - text.length) / 2));
//     return " ".repeat(padding) + text;
//   };

//   const divider = (char = "-") => char.repeat(LINE_WIDTH) + "\n";

//   const formatCurrency = (value) => {
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(Number(value));
//   };


  

//   // Enhanced Cash Drawer Function
//   const openCashDrawer = async () => {
//     try {
//       console.log("Attempting to open cash drawer...");
      
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
      
//       const config = qz.configs.create(PRINTER_NAME);
      
//       // Try different cash drawer commands in sequence
//       const commands = [
//         CASH_DRAWER_COMMANDS.OPEN_DRAWER_PIN2,
//         CASH_DRAWER_COMMANDS.OPEN_DRAWER_PIN5,
//         CASH_DRAWER_COMMANDS.ALTERNATE_1,
//         CASH_DRAWER_COMMANDS.ALTERNATE_2,
//         CASH_DRAWER_COMMANDS.BELL_COMMAND
//       ];
      
//       let drawerOpened = false;
//       let lastError = null;
      
//       for (const command of commands) {
//         try {
//           console.log(`Trying cash drawer command: ${Array.from(command).map(c => c.charCodeAt(0))}`);
//           await qz.print(config, [{ type: "raw", format: "command", data: command }]);
//           console.log("Cash drawer command sent successfully");
//           drawerOpened = true;
//           break;
//         } catch (error) {
//           console.warn(`Cash drawer command failed: ${error.message}`);
//           lastError = error;
//         }
//       }
      
//       if (!drawerOpened) {
//         console.error("All cash drawer commands failed", lastError);
//         throw new Error(`Cash drawer failed to open: ${lastError?.message || 'Unknown error'}`);
//       }
      
//       return drawerOpened;
//     } catch (error) {
//       console.error("Cash drawer error:", error);
//       throw error;
//     }
//   };

//   // Generate thermal receipt commands for QZ Tray
//  const generateThermalReceipt = () => {
//   const subtotal = Number(calculateSubtotal()) + Number(treatmentamount);
//   const totalAmount = Number(calculateTotalAmount());
  
//   // Function to wrap long text into multiple lines
//   const wrapText = (text, maxLength = 24) => {
//     if (text.length <= maxLength) return [text];
    
//     const words = text.split(' ');
//     const lines = [];
//     let currentLine = '';
    
//     for (const word of words) {
//       if ((currentLine + word).length <= maxLength) {
//         currentLine += (currentLine ? ' ' : '') + word;
//       } else {
//         if (currentLine) lines.push(currentLine);
//         // If a single word is longer than maxLength, break it
//         if (word.length > maxLength) {
//           for (let i = 0; i < word.length; i += maxLength) {
//             lines.push(word.substring(i, i + maxLength));
//           }
//           currentLine = '';
//         } else {
//           currentLine = word;
//         }
//       }
//     }
    
//     if (currentLine) lines.push(currentLine);
//     return lines;
//   };

//   const lines = [
//     esc + "@", // Initialize printer
    
//     // Company header - Center aligned and emphasized
//     esc + "a" + "\x01", // Center align
//     esc + "!" + "\x38", // Double height and emphasized
//     "Beauty Bliss\n",
//     esc + "!" + "\x00", // Cancel text formatting
    
//     // Company details
//     esc + "!" + "\x08", // Emphasized
//     "No:128/1,Pahala karagahamuna,Kadawatha.\n",
//     "Tel: 0114532108 | 0117905805\n",
//     "Email: akdldhshana@gmail.com\n",
//     esc + "!" + "\x00", // Cancel emphasis
    
//     divider("="),
    
//     // Receipt title
//     esc + "!" + "\x12", // Medium size
//     esc + "a" + "\x01", // Center align
//     esc + "!" + "\x28", // Double height and emphasized
//     "PAYMENT RECEIPT\n",
//     esc + "!" + "\x00", // Cancel size
//     divider("="),
    
//     // Invoice info
//     leftRight("Invoice:", invoicedetails?.MTD_SERIAL_NO || 'N/A') + "\n",
//     leftRight("Date:", new Date().toLocaleDateString('en-GB')) + "\n",
//     leftRight("Time:", new Date().toLocaleTimeString('en-GB', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     })) + "\n",
    
//     divider("-"),
//     esc + "a" + "\x01" + "PATIENT DETAILS" + "\n" + esc + "a" + "\x00",
//     divider("-"),
    
//     // Patient details - Left aligned
//     `Name: ${patients?.MPD_PATIENT_NAME || 'N/A'}\n`,
//     `Address: ${(patients?.MPD_ADDRESS || 'Not specified').substring(0, 30)}\n`,
//     `Gender/Age: ${patients?.MPD_GENDER || 'N/A'}/${
//       patients?.MPD_BIRTHDAY ? 
//       new Date().getFullYear() - new Date(patients.MPD_BIRTHDAY).getFullYear() : 'N/A'
//     }\n`,
    
//     divider("-"),
//     centerText("BILLING DETAILS") + "\n",
//     divider("-"),
    
//     // Items header
//     esc + "!" + "\x08", // Emphasized
//     leftRight("Item", "Qty  Price   Amount") + "\n",
//     esc + "!" + "\x00", // Cancel emphasis
//     divider("-"),
//   ];

//   // Add medicine items with text wrapping for long names
//   if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
//     invoicedetails.Drugs.forEach(medicinedetail => {
//       const medicineName = medicinedetail.MMC_MATERIAL_SPEC || medicinedetail.DrugName;
//       const wrappedLines = wrapText(medicineName, 24); // Increased to 24 characters
      
//       const qty = medicinedetail.MDD_QUANTITY.toString().padStart(2);
//       const rate = formatCurrency(medicinedetail.MDD_RATE).padStart(6);
//       const amount = formatCurrency(medicinedetail.MDD_AMOUNT).padStart(8);
      
//       // First line with medicine name and amount
//       lines.push(leftRight(wrappedLines[0], `${qty}  ${rate} ${amount}`) + "\n");
      
//       // Additional lines for wrapped text (without amount)
//       for (let i = 1; i < wrappedLines.length; i++) {
//         lines.push(wrappedLines[i] + "\n");
//       }
//     });
//   } else {
//     lines.push(centerText("No medications") + "\n");
//   }

//   // Add totals
//   lines.push(
//     divider("-"),
//     ...(invoicedetails?.Drugs?.length > 0 ? [
//       leftRight("Drug Subtotal:", `Rs. ${formatCurrency(calculateSubtotal())}`) + "\n"
//     ] : []),
//     leftRight("Treatment Fee:", `Rs. ${formatCurrency(treatmentamount)}`) + "\n",
//     leftRight("Subtotal:", `Rs. ${formatCurrency(subtotal)}`) + "\n",
//     ...(discount > 0 ? [
//       leftRight(
//         "Discount:", 
//         discountType === 'percentage' ? 
//         `-${discount}%` : 
//         `-Rs. ${formatCurrency(discount)}`
//       ) + "\n"
//     ] : []),
//     divider("="),
//     esc + "!" + "\x18", // Medium size
//     leftRight("TOTAL:", `Rs. ${formatCurrency(totalAmount)}`) + "\n",
//     esc + "!" + "\x00", // Cancel size
//     divider("="),
//     "\n",
//     centerText("THANK YOU!") + "\n",
//     centerText("Beauty Bliss") + "\n",
//     divider("*"),
//     centerText(new Date().toLocaleString('en-GB')) + "\n",
//     "\n\n\n\n\n", // Extra lines for paper cut
//     gs + "V" + "\x41" + "\x03" // Cut paper
//   );

//   return lines.join("");
// };

//   const printThermalReceipt = async () => {
//     if (isPrinting) return;
    
//     setIsPrinting(true);
    
//     try {
//       // Connect to printer first
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
//       const config = qz.configs.create(PRINTER_NAME);

//       const printData = generateThermalReceipt();

//       // Print the receipt
//       console.log("Printing thermal receipt...");
//       await qz.print(config, [{ type: "raw", format: "command", data: printData }]);
//       console.log("Thermal receipt printed successfully");

//       showMessage('Thermal receipt printed successfully!', 'success');
//       onClose();
//     } catch (err) {
//       console.error("Print process failed:", err);
//       showMessage("Print error: " + err.message, 'error');
//     } finally {
//       setIsPrinting(false);
//     }
//   };

//   // Separate function to just open cash drawer
//   const handleOpenCashDrawer = async () => {
//     if (isOpeningDrawer) return;
    
//     setIsOpeningDrawer(true);
//     try {
//       await openCashDrawer();
//       showMessage("Cash drawer opened successfully!", 'success');
//     } catch (error) {
//       console.error("Cash drawer error:", error);
//       showMessage("Error opening cash drawer: " + error.message, 'error');
//     } finally {
//       setIsOpeningDrawer(false);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" alignItems="center" gap={1}>
//             <ReceiptLong color="primary" />
//             QZ Tray Thermal Printing
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//             Direct printing to thermal printer using QZ Tray
//           </Typography>
          
//           <Card variant="outlined" sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Receipt Preview (Thermal Format)
//               </Typography>
//               <Paper 
//                 variant="outlined" 
//                 sx={{ 
//                   p: 2, 
//                   backgroundColor: '#f5f5f5', 
//                   fontFamily: 'Courier New, monospace', 
//                   fontSize: '12px', 
//                   lineHeight: '1.2', 
//                   whiteSpace: 'pre',
//                   maxHeight: '400px',
//                   overflow: 'auto',
//                   border: '1px dashed #ccc'
//                 }}
//               >
//                 {generateThermalReceipt().replace(/\x1B\[.*?m/g, '')} {/* Remove escape sequences for preview */}
//               </Paper>
//             </CardContent>
//           </Card>

//           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
//             <Button 
//               variant="outlined" 
//               onClick={handleOpenCashDrawer}
//               disabled={isOpeningDrawer}
//               startIcon={<Receipt />}
//             >
//               {isOpeningDrawer ? "Opening..." : "Test Cash Drawer"}
//             </Button>
//             <Typography variant="body2" color="text.secondary">
//               Printer: {PRINTER_NAME}
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={onClose}>Cancel</Button>
//           <Button 
//             onClick={printThermalReceipt} 
//             variant="contained" 
//             color="primary"
//             startIcon={<Print />}
//             disabled={isPrinting}
//           >
//             {isPrinting ? "Printing..." : "Print Thermal Receipt"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar 
//         open={printStatus.open} 
//         autoHideDuration={6000} 
//         onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           severity={printStatus.severity} 
//           onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         >
//           {printStatus.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// // Main Invoice Component
// export default function Invoice() {
//   const { patientId, serial_no } = useParams();
//   const [patients, setPatients] = useState(null);
//   const [invoicedetails, setInvoicedetails] = useState(null);
//   const [treatmentamount, setTreatmentamount] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [discountType, setDiscountType] = useState("percentage");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [qzTrayDialogOpen, setQzTrayDialogOpen] = useState(false);
//   const navigate = useNavigate();


//   const [smsLoading, setSmsLoading] = useState(false);
//   const [smsStatus, setSmsStatus] = useState({ open: false, message: '', severity: 'info' });

//   const sendSmsBill = async () => {
//   if (!patients || !invoicedetails) return;

//   setSmsLoading(true);

//   try {
//     const totalAmount = calculateTotalAmount();
//     const subtotal = Number(calculateSubtotal()) + Number(treatmentamount);
    
//     // Build product details
//     let productDetails = "";
    
//     if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
//       invoicedetails.Drugs.forEach((item) => {
//         const itemName = item.MMC_MATERIAL_SPEC || item.DrugName || "Item";
//         const amount = item.MDD_AMOUNT ? new Intl.NumberFormat('en-US', {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//         }).format(Number(item.MDD_AMOUNT)) : "0.00";
        
//         productDetails += `${itemName}: Rs. ${amount}\n`;
//       });
//     }

//     // Add treatment charges if applicable
//     let treatmentSection = "";
//     if (treatmentamount && Number(treatmentamount) > 0) {
//       treatmentSection = `Treatment Charges: Rs. ${new Intl.NumberFormat('en-US', {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//       }).format(Number(treatmentamount))}\n`;
//     }

//     // Calculate discount amount properly
//     const discountAmount = discountType === 'percentage' 
//       ? (subtotal * discount / 100)
//       : Number(discount);

//     // Format all amounts with commas (thousands separators)
//     const formatWithCommas = (value) => {
//       return new Intl.NumberFormat('en-US', {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//       }).format(Number(value));
//     };

//     const formattedSubtotal = formatWithCommas(subtotal);
//     const formattedDiscount = formatWithCommas(discountAmount);
//     const formattedTotal = formatWithCommas(totalAmount);

//     // Construct the exact message format you want
//     const message = `${productDetails}${treatmentSection}Subtotal: Rs. ${formattedSubtotal}
// Discount: Rs. ${formattedDiscount}
// Balance Due: Rs. ${formattedTotal}

// Thank you for choosing BeautyBliss!
// Please arrange the payment at your earliest convenience.`;

//     console.log("SMS Message:", message); // For debugging

//     // API request
//     const response = await axios.post(
//       `${process.env.REACT_APP_API_BASE_URL}/Appointment/send-Invoice-messages`,
//       {
//         Message: message,
//         Contacts: [patients.MPD_MOBILE_NO]
//       }
//     );

//     console.log("SMS Response:", response.data);
    
//     if (response.data && response.data.success > 0) {
//       setSmsStatus({ 
//         open: true, 
//         message: `SMS bill sent successfully to ${response.data.success} contact(s)!`, 
//         severity: 'success' 
//       });
//     } else {
//       setSmsStatus({ 
//         open: true, 
//         message: 'SMS sending completed but no successful deliveries', 
//         severity: 'warning' 
//       });
//     }
    
//   } catch (error) {
//     console.error("SMS Error:", error);
//     let errorMessage = 'Failed to send SMS bill';
    
//     if (error.response?.data) {
//       errorMessage = error.response.data;
//     } else if (error.message) {
//       errorMessage = error.message;
//     }
    
//     setSmsStatus({ 
//       open: true, 
//       message: errorMessage, 
//       severity: 'error' 
//     });
//   } finally {
//     setSmsLoading(false);
//   }
// };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const [treatmentRes, patientRes] = await Promise.all([
//           axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
//           ),
//           axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
//           ),
//         ]);
//         setInvoicedetails(treatmentRes.data);
//         setTreatmentamount(treatmentRes.data.MTD_AMOUNT || 0);
//         setPatients(patientRes.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setError(error.response?.data?.message || "Failed to fetch data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [patientId, serial_no]);

//   const calculateSubtotal = () => {
//     if (invoicedetails && invoicedetails.Drugs) {
//       const total = invoicedetails.Drugs.reduce(
//         (total, drug) => total + drug.MDD_AMOUNT,
//         0
//       );
//       return total.toFixed(2);
//     }
//     return 0;
//   };

//   const calculateTotalAmount = () => {
//     const subtotal =
//       parseFloat(calculateSubtotal()) + parseFloat(treatmentamount);
//     let totalAmount = subtotal;

//     if (discountType === "percentage") {
//       totalAmount -= (subtotal * discount) / 100;
//     } else {
//       totalAmount -= discount;
//     }

//     return totalAmount.toFixed(2);
//   };

//   const printInvoice = () => {
//     const noPrintElements = document.querySelectorAll('.no-print');
//     noPrintElements.forEach(element => {
//       element.style.display = 'none';
//     });

//     const printStyles = document.createElement('style');
//     printStyles.innerHTML = `
//     @media print {
//       body * {
//         visibility: hidden;
//       }
      
//       #invoice-content, #invoice-content * {
//         visibility: visible;
//       }
      
//       #invoice-content {
//         position: absolute;
//         left: 0;
//         top: 0;
//         width: 100%;
//       }
      
//       .MuiContainer-root {
//         max-width: none !important;
//         padding: 0 !important;
//         margin: 0 !important;
//       }
      
//       .MuiPaper-root {
//         boxShadow: none !important;
//         border: none !important;
//         margin: 0 !important;
//         padding: 20px !important;
//       }
      
//       @page {
//         size: A4;
//         margin: 15mm;
//       }
//     }
//   `;

//     document.head.appendChild(printStyles);
//     window.print();

//     setTimeout(() => {
//       document.head.removeChild(printStyles);
//       noPrintElements.forEach(element => {
//         element.style.display = '';
//       });
//     }, 100);
//   };

//   const downloadInvoice = () => {
//     const element = document.getElementById("invoice-content");
//     const opt = {
//       margin: [10, 10, 10, 10],
//       filename: `invoice_${patientId}_${serial_no}.pdf`,
//       image: {
//         type: "jpeg",
//         quality: 0.98
//       },
//       html2canvas: {
//         scale: 2,
//         logging: false,
//         useCORS: true,
//         allowTaint: true,
//         backgroundColor: '#ffffff',
//         ignoreElements: function (element) {
//           return element.classList.contains('no-print');
//         }
//       },
//       jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "portrait",
//         putOnlyUsedFonts: true,
//         floatPrecision: 16
//       },
//       pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
//     };
//     const tempStyles = document.createElement('style');
//     tempStyles.innerHTML = `
//       .invoice-number-pdf {
//         backgroundColor: theme.palette.secondary.main;
//         color: white !important;
//         -webkit-print-color-adjust: exact !important;
//         color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//     `;
//     document.head.appendChild(tempStyles);

//     html2pdf().set(opt).from(element).save().then(() => {
//       document.head.removeChild(tempStyles);
//     });
//   };

//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="80vh"
//       >
//         <CircularProgress size={60} />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//           <Typography variant="h6" color="error">
//             {error}
//           </Typography>
//           <Button
//             variant="contained"
//             color="primary"
//             sx={{ mt: 2 }}
//             onClick={() => window.location.reload()}
//           >
//             Retry
//           </Button>
//         </Paper>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="xl" sx={{ py: 4 }}>
//       <Box sx={{ mb: 3 }} className="no-print">
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={() => navigate(-1)}
//           variant="outlined"
//         >
//           Back to Records
//         </Button>
//       </Box>

//       <StyledPaper elevation={3} id="invoice-content">
//         <HeaderBox>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Avatar
//               src={logo}
//               alt="Medicare Logo"
//               variant="rounded"
//               sx={{ width: 80, height: 80, '@media print': { width: 60, height: 60 } }}
//             />
//             <Box>
//               <Typography variant="h5" fontWeight="bold" color="primary" sx={{ '@media print': { fontSize: '2rem' } }}>
//                 BEAUTY BLISS
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 202/A, Mandawala Road,Malamulla,Panadura.
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 Tel: 076 380 9974
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 Web: www.beautyblissbyprima.com
//               </Typography>
//             </Box>
//           </Box>

//           <Box sx={{ textAlign: "right" }}>
//             <Typography  color="primary"  sx={{ '@media print': { fontSize: '0.9rem' } }}>
//               Payment Receipt
//             </Typography>
//             <InvoiceNumberBox className="invoice-number-pdf">
//               Invoice - {invoicedetails?.MTD_SERIAL_NO || "N/A"}
//             </InvoiceNumberBox>
//           </Box>
//         </HeaderBox>

//         <Divider sx={{ my: 3 }} />

//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: { xs: 2, sm: 3 },
//             mb: 4,
//             alignItems: "center",
//             justifyContent: "space-between",
//             '& > *': {
//               flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 24px)', md: '1 1 calc(25% - 24px)' },
//               minWidth: { xs: '100%', sm: '200px' },
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//             },
//             '@media print': {
//               gap: 2,
//               marginBottom: '16px',
//               '& > *': {
//                 flex: '1 1 calc(25% - 16px)',
//                 minWidth: 'auto'
//               }
//             }
//           }}
//         >
//           <Box>
//             <Person color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Customer Name
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {patients?.MPD_PATIENT_NAME}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <Home color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Address
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{
//                 '@media print': { fontSize: '1rem' },
//                 display: '-webkit-box',
//                 WebkitLineClamp: 1,
//                 WebkitBoxOrient: 'vertical',
//                 overflow: 'hidden'
//               }}>
//                 {patients?.MPD_ADDRESS || "Not specified"}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <CalendarToday color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Date
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {new Date().toLocaleDateString()}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             {patients?.MPD_GENDER === "Male" ? (
//               <Male color="primary" />
//             ) : (
//               <Female color="primary" />
//             )}
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Gender / Age
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {patients?.MPD_GENDER} /{" "}
//                 {patients?.MPD_BIRTHDAY
//                   ? new Date().getFullYear() -
//                   new Date(patients.MPD_BIRTHDAY).getFullYear()
//                   : "N/A"}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         <TableContainer
//           component={Paper}
//           elevation={0}
//           sx={{ border: "1px solid #eee", mb: 4 }}
//         >
//           <Table>
//             <TableHead sx={{ backgroundColor: "primary.main" }}>
//               <TableRow>
//                 <TableCell sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}>
//                  Products and Treatments
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Rate (Rs)
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Quantity
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Amount (Rs)
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {invoicedetails?.Drugs?.map((medicinedetail, index) => (
//                 <TableRow key={index} hover>
//                   <TableCell sx={{ '@media print': { fontSize: '0.9rem' } }}>{medicinedetail.DrugName}</TableCell>
//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_RATE
//                       ? new Intl.NumberFormat('en-US', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       }).format(Number(medicinedetail.MDD_RATE))
//                       : "0.00"}
//                   </TableCell>

//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_QUANTITY
//                       ? new Intl.NumberFormat('en-US').format(Number(medicinedetail.MDD_QUANTITY))
//                       : "0"}
//                   </TableCell>

//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_AMOUNT
//                       ? new Intl.NumberFormat('en-US', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       }).format(Number(medicinedetail.MDD_AMOUNT))
//                       : "0.00"}
//                   </TableCell>
//                 </TableRow>
//               ))}

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ 
//                   '@media print': { fontSize: '0.9rem' },
//                   fontSize: '0.9rem'  // Smaller font size for Total Treatment Fee
//                 }}>
//                   Total Treatment Fee:
//                 </TableCell>
//                 <TableCell align="right" sx={{ 
//                   '@media print': { fontSize: '1rem' },
//                   fontSize: '0.9rem'  // Smaller font size for amount
//                 }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(Number(calculateSubtotal()))}
//                 </TableCell>
//               </TotalRow>

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ 
//                   '@media print': { fontSize: '0.9rem' },
//                   fontSize: '0.9rem'  // Smaller font size for Treatment Fee
//                 }}>
//                   Treatment Fee:
//                 </TableCell>
//                 <TableCell align="right" sx={{ 
//                   '@media print': { fontSize: '1rem' },
//                   fontSize: '0.9rem'  // Smaller font size for amount
//                 }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(Number(treatmentamount))}
//                 </TableCell>
//               </TotalRow>

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ 
//                   '@media print': { fontSize: '0.9rem' },
//                   fontSize: '0.9rem'  // Smaller font size for Subtotal
//                 }}>
//                   Subtotal:
//                 </TableCell>
//                 <TableCell align="right" sx={{ 
//                   '@media print': { fontSize: '1rem' },
//                   fontSize: '0.9rem'  // Smaller font size for amount
//                 }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(
//                     Number(calculateSubtotal()) + Number(treatmentamount)
//                   )}
//                 </TableCell>
//               </TotalRow>

//               <DiscountRow>
//                 <TableCell colSpan={1}></TableCell>
//                 <TableCell>
//                   <Typography fontWeight="bold" sx={{ '@media print': { fontSize: '0.9rem' } }}>Discount</Typography>
//                   <RadioGroup
//                     row
//                     value={discountType}
//                     onChange={(e) => setDiscountType(e.target.value)}
//                     sx={{ mt: 1 }}
//                   >
//                     <FormControlLabel
//                       value="percentage"
//                       control={<Radio size="small" />}
//                       label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Percentage</Typography>}
//                     />
//                     <FormControlLabel
//                       value="fixed"
//                       control={<Radio size="small" />}
//                       label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Fixed Amount</Typography>}
//                     />
//                   </RadioGroup>
//                 </TableCell>
//                 <TableCell align="right">
//                   <TextField
//                     type="number"
//                     size="small"
//                     value={discount}
//                     onChange={(e) => setDiscount(e.target.value)}
//                     inputProps={{
//                       min: "0",
//                       max:
//                         discountType === "percentage"
//                           ? "100"
//                           : parseFloat(calculateSubtotal()) +
//                           parseFloat(treatmentamount),
//                     }}
//                     sx={{ width: 120 }}
//                   />
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   {discountType === "percentage"
//                     ? `${discount}%`
//                     : `Rs: ${discount}`}
//                 </TableCell>
//               </DiscountRow>

//               <TotalRow sx={{ backgroundColor: "primary.light" }}>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ color: "common.white", '@media print': { fontSize: '0.9rem' } }}>
//                   <Typography variant="h6">Final Amount:</Typography>
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   <Typography variant="h6">
//                     Rs: {new Intl.NumberFormat('en-US', {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2
//                     }).format(Number(calculateTotalAmount()))}
//                   </Typography>
//                 </TableCell>
//               </TotalRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Box
//           sx={{
//             mt: 6,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "flex-end",
//           }}
//         >
//           <Box
//             sx={{
//               width: 300,
//               textAlign: "center",
//               p: 2,
//             }}
//           >
//             <Divider sx={{ mb: 2 }} />
//             <Typography variant="body1" color="text.secondary" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//               Authorized Signature
//             </Typography>
//             <Typography variant="h6" fontWeight="bold" sx={{ mt: 1, '@media print': { fontSize: '0.9rem' } }}>
//              Beauty Bliss
//             </Typography>
//           </Box>
//         </Box>
//       </StyledPaper>

//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           gap: 3,
//           mt: 4,
//           "@media print": {
//             display: "none",
//           },
//         }}
//         className="no-print"
//       >
//         <Tooltip title="Print standard invoice">
//           <Button
//             variant="contained"
//             color="primary"
//             startIcon={<Print />}
//             onClick={printInvoice}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Print Invoice
//           </Button>
//         </Tooltip>
//          <Tooltip title="Send Invoice via SMS">
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={<SendIcon />}
//               onClick={sendSmsBill}
//               sx={{ px: 4, py: 1.5 }}
//               disabled={smsLoading}
//             >
//               {smsLoading ? "Sending..." : "SMS Bill"}
//             </Button>
//           </Tooltip>

//         <Tooltip title="Print thermal receipt via QZ Tray">
//           <Button
//             variant="contained"
//             color="secondary"
//             startIcon={<ReceiptLong />}
//             onClick={() => setQzTrayDialogOpen(true)}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             QZ Tray Print
//           </Button>
//         </Tooltip>

//         <Tooltip title="Download as PDF">
//           <Button
//             variant="outlined"
//             color="primary"
//             startIcon={<Download />}
//             onClick={downloadInvoice}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Download PDF
//           </Button>
//         </Tooltip>
//       </Box>

//     <Snackbar
//       open={smsStatus.open}
//       autoHideDuration={6000}
//       onClose={() => setSmsStatus({ ...smsStatus, open: false })}
//       anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//     >
//       <Alert
//         severity={smsStatus.severity}
//         onClose={() => setSmsStatus({ ...smsStatus, open: false })}
//         sx={{ width: "100%" }}
//       >
//         {smsStatus.message}
//       </Alert>
//     </Snackbar>

//       {/* QZ Tray Thermal Printing Dialog */}
//       <QZTrayThermalPrint
//         open={qzTrayDialogOpen}
//         onClose={() => setQzTrayDialogOpen(false)}
//         patients={patients}
//         invoicedetails={invoicedetails}
//         treatmentamount={treatmentamount}
//         discount={discount}
//         discountType={discountType}
//         calculateSubtotal={calculateSubtotal}
//         calculateTotalAmount={calculateTotalAmount}
//       />
//     </Container>
//   );
// }

import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Grid,
  Tooltip,
  CircularProgress,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Alert,
  Snackbar,
} from "@mui/material";
import {
  ArrowBack,
  Print,
  Download,
  LocalHospital,
  Person,
  Receipt,
  Phone,
  Email,
  Language,
  Home,
  CalendarToday,
  Male,
  Female,
  ReceiptLong,
  ContentCopy,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import logo from "../assets/saloonlogo.png";
import html2pdf from "html2pdf.js";
import { NumericFormat } from 'react-number-format';
import qz from "qz-tray";
import SendIcon from '@mui/icons-material/Send';



const PRINTER_NAME = "BIXOLON SRP-E302"; // Change to your thermal printer name

// Enhanced Cash drawer commands for thermal printers
const CASH_DRAWER_COMMANDS = {
  OPEN_DRAWER_PIN2: "\x1B\x70\x00\x19\xFA",
  OPEN_DRAWER_PIN5: "\x1B\x70\x01\x19\xFA",
  ALTERNATE_1: "\x1B\x70\x00\x60\x60",
  ALTERNATE_2: "\x1B\x70\x01\x60\x60",
  BELL_COMMAND: "\x07",
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
  maxWidth: 1500,
  margin: "0 auto",
  "@media print": {
    boxShadow: "none",
    padding: theme.spacing(3),
    border: "1px solid #ddd",
    backgroundColor: "#fff",
  },
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(4),
  "@media (max-width: 600px)": {
    flexDirection: "column",
    gap: theme.spacing(2),
    alignItems: "flex-start",
  },
  "@media print": {
    flexDirection: "row",
    alignItems: "center",
  },
}));

const TotalRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  "& td": {
    fontWeight: "bold",
    fontSize: "0.9rem",
  },
}));

const DiscountRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  "& td": {
    padding: theme.spacing(2),
  },
}));

// Dark Theme Info Box - Updated with print styles
const DarkInfoBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#121212',
  color: '#ffffff',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  border: '1px solid #333',
  minWidth: '200px',
  flex: '1 1 calc(25% - 24px)',
  marginBottom: theme.spacing(2),
  '@media (max-width: 600px)': {
    flex: '1 1 100%',
  },
  '& .MuiTypography-caption': {
    color: '#b0b0b0',
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: theme.spacing(0.5),
  },
  '& .MuiTypography-body1': {
    color: '#ffffff',
    fontWeight: 500,
    fontSize: '0.9rem',
  },
  // Print styles
  '@media print': {
    backgroundColor: '#f5f5f5 !important',
    color: '#000 !important',
    border: '1px solid #ddd !important',
    printColorAdjust: 'exact',
    WebkitPrintColorAdjust: 'exact',
    '& .MuiTypography-caption': {
      color: '#666 !important',
    },
    '& .MuiTypography-body1': {
      color: '#000 !important',
    },
  },
}));

// const InvoiceNumberBox = styled(Box)(({ theme }) => ({
//   backgroundColor: theme.palette.secondary.main,
//   color: 'white',
//   padding: '6px 12px',
//   borderRadius: '16px',
//   display: 'inline-block',
//   marginTop: theme.spacing(1),
//   fontSize: '0.875rem',
//   fontWeight: 500,
//   '-webkit-print-color-adjust': 'exact',
//   'color-adjust': 'exact',
//   'print-color-adjust': 'exact',
// }));

const InvoiceNumberBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  padding: theme.spacing(0.75, 2),
  borderRadius: theme.shape.borderRadius * 2,
  display: "inline-flex",
  alignItems: "center",
  fontSize: "0.9rem",
  fontWeight: 600,
  letterSpacing: "0.3px",
  marginTop: theme.spacing(1.2),
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",

  // Print adjustments
  printColorAdjust: "exact",
  WebkitPrintColorAdjust: "exact",
}));




// QZ Tray Thermal Printing Component
const QZTrayThermalPrint = ({ 
  open, 
  onClose, 
  patients, 
  invoicedetails, 
  treatmentamount, 
  discount, 
  discountType, 
  calculateSubtotal, 
  calculateTotalAmount 
}) => {
  const [printStatus, setPrintStatus] = useState({ open: false, message: '', severity: 'info' });
  const [isPrinting, setIsPrinting] = useState(false);
  const [isOpeningDrawer, setIsOpeningDrawer] = useState(false);
  
   

  const showMessage = (message, severity = 'info') => {
    setPrintStatus({ open: true, message, severity });
  };

  // Thermal printer formatting constants
  const esc = "\x1B";
  const gs = "\x1D";
  const LINE_WIDTH = 48; // 80mm thermal printer width

  const leftRight = (left, right, width = LINE_WIDTH) => {
    const space = width - (left.length + right.length);
    return left + " ".repeat(space > 0 ? space : 1) + right;
  };

  const centerText = (text, width = LINE_WIDTH) => {
    const padding = Math.max(0, Math.floor((width - text.length) / 2));
    return " ".repeat(padding) + text;
  };

  const divider = (char = "-") => char.repeat(LINE_WIDTH) + "\n";

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value));
  };


  

  // Enhanced Cash Drawer Function
  const openCashDrawer = async () => {
    try {
      console.log("Attempting to open cash drawer...");
      
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }
      
      const config = qz.configs.create(PRINTER_NAME);
      
      // Try different cash drawer commands in sequence
      const commands = [
        CASH_DRAWER_COMMANDS.OPEN_DRAWER_PIN2,
        CASH_DRAWER_COMMANDS.OPEN_DRAWER_PIN5,
        CASH_DRAWER_COMMANDS.ALTERNATE_1,
        CASH_DRAWER_COMMANDS.ALTERNATE_2,
        CASH_DRAWER_COMMANDS.BELL_COMMAND
      ];
      
      let drawerOpened = false;
      let lastError = null;
      
      for (const command of commands) {
        try {
          console.log(`Trying cash drawer command: ${Array.from(command).map(c => c.charCodeAt(0))}`);
          await qz.print(config, [{ type: "raw", format: "command", data: command }]);
          console.log("Cash drawer command sent successfully");
          drawerOpened = true;
          break;
        } catch (error) {
          console.warn(`Cash drawer command failed: ${error.message}`);
          lastError = error;
        }
      }
      
      if (!drawerOpened) {
        console.error("All cash drawer commands failed", lastError);
        throw new Error(`Cash drawer failed to open: ${lastError?.message || 'Unknown error'}`);
      }
      
      return drawerOpened;
    } catch (error) {
      console.error("Cash drawer error:", error);
      throw error;
    }
  };

  // Generate thermal receipt commands for QZ Tray
 const generateThermalReceipt = () => {
  const subtotal = Number(calculateSubtotal()) + Number(treatmentamount);
  const totalAmount = Number(calculateTotalAmount());
  
  // Function to wrap long text into multiple lines
  const wrapText = (text, maxLength = 24) => {
    if (text.length <= maxLength) return [text];
    
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';
    
    for (const word of words) {
      if ((currentLine + word).length <= maxLength) {
        currentLine += (currentLine ? ' ' : '') + word;
      } else {
        if (currentLine) lines.push(currentLine);
        // If a single word is longer than maxLength, break it
        if (word.length > maxLength) {
          for (let i = 0; i < word.length; i += maxLength) {
            lines.push(word.substring(i, i + maxLength));
          }
          currentLine = '';
        } else {
          currentLine = word;
        }
      }
    }
    
    if (currentLine) lines.push(currentLine);
    return lines;
  };

  const lines = [
    esc + "@", // Initialize printer
    
    // Company header - Center aligned and emphasized
    esc + "a" + "\x01", // Center align
    esc + "!" + "\x38", // Double height and emphasized
    "Beauty Bliss\n",
    esc + "!" + "\x00", // Cancel text formatting
    
    // Company details
    esc + "!" + "\x08", // Emphasized
    "No:128/1,Pahala karagahamuna,Kadawatha.\n",
    "Tel: 0114532108 | 0117905805\n",
    "Email: akdldhshana@gmail.com\n",
    esc + "!" + "\x00", // Cancel emphasis
    
    divider("="),
    
    // Receipt title
    esc + "!" + "\x12", // Medium size
    esc + "a" + "\x01", // Center align
    esc + "!" + "\x28", // Double height and emphasized
    "PAYMENT RECEIPT\n",
    esc + "!" + "\x00", // Cancel size
    divider("="),
    
    // Invoice info
    leftRight("Invoice:", invoicedetails?.MTD_SERIAL_NO || 'N/A') + "\n",
    leftRight("Date:", new Date().toLocaleDateString('en-GB')) + "\n",
    leftRight("Time:", new Date().toLocaleTimeString('en-GB', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    })) + "\n",
    
    divider("-"),
    esc + "a" + "\x01" + "PATIENT DETAILS" + "\n" + esc + "a" + "\x00",
    divider("-"),
    
    // Patient details - Left aligned
    `Name: ${patients?.MPD_PATIENT_NAME || 'N/A'}\n`,
    `Address: ${(patients?.MPD_ADDRESS || 'Not specified').substring(0, 30)}\n`,
    `Gender/Age: ${patients?.MPD_GENDER || 'N/A'}/${
      patients?.MPD_BIRTHDAY ? 
      new Date().getFullYear() - new Date(patients.MPD_BIRTHDAY).getFullYear() : 'N/A'
    }\n`,
    
    divider("-"),
    centerText("BILLING DETAILS") + "\n",
    divider("-"),
    
    // Items header
    esc + "!" + "\x08", // Emphasized
    leftRight("Item", "Qty  Price   Amount") + "\n",
    esc + "!" + "\x00", // Cancel emphasis
    divider("-"),
  ];

  // Add medicine items with text wrapping for long names
  if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
    invoicedetails.Drugs.forEach(medicinedetail => {
      const medicineName = medicinedetail.MMC_MATERIAL_SPEC || medicinedetail.DrugName;
      const wrappedLines = wrapText(medicineName, 24); // Increased to 24 characters
      
      const qty = medicinedetail.MDD_QUANTITY.toString().padStart(2);
      const rate = formatCurrency(medicinedetail.MDD_RATE).padStart(6);
      const amount = formatCurrency(medicinedetail.MDD_AMOUNT).padStart(8);
      
      // First line with medicine name and amount
      lines.push(leftRight(wrappedLines[0], `${qty}  ${rate} ${amount}`) + "\n");
      
      // Additional lines for wrapped text (without amount)
      for (let i = 1; i < wrappedLines.length; i++) {
        lines.push(wrappedLines[i] + "\n");
      }
    });
  } else {
    lines.push(centerText("No medications") + "\n");
  }

  // Add totals
  lines.push(
    divider("-"),
    ...(invoicedetails?.Drugs?.length > 0 ? [
      leftRight("Drug Subtotal:", `Rs. ${formatCurrency(calculateSubtotal())}`) + "\n"
    ] : []),
    leftRight("Treatment Fee:", `Rs. ${formatCurrency(treatmentamount)}`) + "\n",
    leftRight("Subtotal:", `Rs. ${formatCurrency(subtotal)}`) + "\n",
    ...(discount > 0 ? [
      leftRight(
        "Discount:", 
        discountType === 'percentage' ? 
        `-${discount}%` : 
        `-Rs. ${formatCurrency(discount)}`
      ) + "\n"
    ] : []),
    divider("="),
    esc + "!" + "\x18", // Medium size
    leftRight("TOTAL:", `Rs. ${formatCurrency(totalAmount)}`) + "\n",
    esc + "!" + "\x00", // Cancel size
    divider("="),
    "\n",
    centerText("THANK YOU!") + "\n",
    centerText("Beauty Bliss") + "\n",
    divider("*"),
    centerText(new Date().toLocaleString('en-GB')) + "\n",
    "\n\n\n\n\n", // Extra lines for paper cut
    gs + "V" + "\x41" + "\x03" // Cut paper
  );

  return lines.join("");
};

  const printThermalReceipt = async () => {
    if (isPrinting) return;
    
    setIsPrinting(true);
    
    try {
      // Connect to printer first
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }
      const config = qz.configs.create(PRINTER_NAME);

      const printData = generateThermalReceipt();

      // Print the receipt
      console.log("Printing thermal receipt...");
      await qz.print(config, [{ type: "raw", format: "command", data: printData }]);
      console.log("Thermal receipt printed successfully");

      showMessage('Thermal receipt printed successfully!', 'success');
      onClose();
    } catch (err) {
      console.error("Print process failed:", err);
      showMessage("Print error: " + err.message, 'error');
    } finally {
      setIsPrinting(false);
    }
  };

  // Separate function to just open cash drawer
  const handleOpenCashDrawer = async () => {
    if (isOpeningDrawer) return;
    
    setIsOpeningDrawer(true);
    try {
      await openCashDrawer();
      showMessage("Cash drawer opened successfully!", 'success');
    } catch (error) {
      console.error("Cash drawer error:", error);
      showMessage("Error opening cash drawer: " + error.message, 'error');
    } finally {
      setIsOpeningDrawer(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={1}>
            <ReceiptLong color="primary" />
            QZ Tray Thermal Printing
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Direct printing to thermal printer using QZ Tray
          </Typography>
          
          <Card variant="outlined" sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Receipt Preview (Thermal Format)
              </Typography>
              <Paper 
                variant="outlined" 
                sx={{ 
                  p: 2, 
                  backgroundColor: '#f5f5f5', 
                  fontFamily: 'Courier New, monospace', 
                  fontSize: '12px', 
                  lineHeight: '1.2', 
                  whiteSpace: 'pre',
                  maxHeight: '400px',
                  overflow: 'auto',
                  border: '1px dashed #ccc'
                }}
              >
                {generateThermalReceipt().replace(/\x1B\[.*?m/g, '')} {/* Remove escape sequences for preview */}
              </Paper>
            </CardContent>
          </Card>

          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
            <Button 
              variant="outlined" 
              onClick={handleOpenCashDrawer}
              disabled={isOpeningDrawer}
              startIcon={<Receipt />}
            >
              {isOpeningDrawer ? "Opening..." : "Test Cash Drawer"}
            </Button>
            <Typography variant="body2" color="text.secondary">
              Printer: {PRINTER_NAME}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button 
            onClick={printThermalReceipt} 
            variant="contained" 
            color="primary"
            startIcon={<Print />}
            disabled={isPrinting}
          >
            {isPrinting ? "Printing..." : "Print Thermal Receipt"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar 
        open={printStatus.open} 
        autoHideDuration={6000} 
        onClose={() => setPrintStatus({ ...printStatus, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          severity={printStatus.severity} 
          onClose={() => setPrintStatus({ ...printStatus, open: false })}
        >
          {printStatus.message}
        </Alert>
      </Snackbar>
    </>
  );
};

// Main Invoice Component
export default function Invoice() {
  const { patientId, serial_no } = useParams();
  const [patients, setPatients] = useState(null);
  const [invoicedetails, setInvoicedetails] = useState(null);
  const [treatmentamount, setTreatmentamount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("percentage");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [qzTrayDialogOpen, setQzTrayDialogOpen] = useState(false);
  const navigate = useNavigate();


  const [smsLoading, setSmsLoading] = useState(false);
  const [smsStatus, setSmsStatus] = useState({ open: false, message: '', severity: 'info' });

  const sendSmsBill = async () => {
  if (!patients || !invoicedetails) return;

  setSmsLoading(true);

  try {
    const totalAmount = calculateTotalAmount();
    const subtotal = Number(calculateSubtotal()) + Number(treatmentamount);
    
    // Build product details
    let productDetails = "";
    
    if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
      invoicedetails.Drugs.forEach((item) => {
        const itemName = item.MMC_MATERIAL_SPEC || item.DrugName || "Item";
        const amount = item.MDD_AMOUNT ? new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(Number(item.MDD_AMOUNT)) : "0.00";
        
        productDetails += `${itemName}: Rs. ${amount}\n`;
      });
    }

    // Add treatment charges if applicable
    let treatmentSection = "";
    if (treatmentamount && Number(treatmentamount) > 0) {
      treatmentSection = `Treatment Charges: Rs. ${new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(treatmentamount))}\n`;
    }

    // Calculate discount amount properly
    const discountAmount = discountType === 'percentage' 
      ? (subtotal * discount / 100)
      : Number(discount);

    // Format all amounts with commas (thousands separators)
    const formatWithCommas = (value) => {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(value));
    };

    const formattedSubtotal = formatWithCommas(subtotal);
    const formattedDiscount = formatWithCommas(discountAmount);
    const formattedTotal = formatWithCommas(totalAmount);

    // Construct the exact message format you want
    const message = `${productDetails}${treatmentSection}Subtotal: Rs. ${formattedSubtotal}
Discount: Rs. ${formattedDiscount}
Balance Due: Rs. ${formattedTotal}

Thank you for choosing BeautyBliss!
Please arrange the payment at your earliest convenience.`;

    console.log("SMS Message:", message); // For debugging

    // API request
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/Appointment/send-Invoice-messages`,
      {
        Message: message,
        Contacts: [patients.MPD_MOBILE_NO]
      }
    );

    console.log("SMS Response:", response.data);
    
    if (response.data && response.data.success > 0) {
      setSmsStatus({ 
        open: true, 
        message: `SMS bill sent successfully to ${response.data.success} contact(s)!`, 
        severity: 'success' 
      });
    } else {
      setSmsStatus({ 
        open: true, 
        message: 'SMS sending completed but no successful deliveries', 
        severity: 'warning' 
      });
    }
    
  } catch (error) {
    console.error("SMS Error:", error);
    let errorMessage = 'Failed to send SMS bill';
    
    if (error.response?.data) {
      errorMessage = error.response.data;
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    setSmsStatus({ 
      open: true, 
      message: errorMessage, 
      severity: 'error' 
    });
  } finally {
    setSmsLoading(false);
  }
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [treatmentRes, patientRes] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
          ),
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
          ),
        ]);
        setInvoicedetails(treatmentRes.data);
        setTreatmentamount(treatmentRes.data.MTD_AMOUNT || 0);
        setPatients(patientRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.response?.data?.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [patientId, serial_no]);

  const calculateSubtotal = () => {
    if (invoicedetails && invoicedetails.Drugs) {
      const total = invoicedetails.Drugs.reduce(
        (total, drug) => total + drug.MDD_AMOUNT,
        0
      );
      return total.toFixed(2);
    }
    return 0;
  };

  const calculateTotalAmount = () => {
    const subtotal =
      parseFloat(calculateSubtotal()) + parseFloat(treatmentamount);
    let totalAmount = subtotal;

    if (discountType === "percentage") {
      totalAmount -= (subtotal * discount) / 100;
    } else {
      totalAmount -= discount;
    }

    return totalAmount.toFixed(2);
  };

  const printInvoice = () => {
    const noPrintElements = document.querySelectorAll('.no-print');
    noPrintElements.forEach(element => {
      element.style.display = 'none';
    });

    const printStyles = document.createElement('style');
    printStyles.innerHTML = `
    @media print {
      body * {
        visibility: hidden;
      }
      
      #invoice-content, #invoice-content * {
        visibility: visible;
      }
      
      #invoice-content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        background-color: white !important;
      }
      
      .MuiContainer-root {
        max-width: none !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      
      .MuiPaper-root {
        boxShadow: none !important;
        border: none !important;
        margin: 0 !important;
        padding: 20px !important;
        background-color: white !important;
      }
      
      /* Force dark boxes to show as light gray in print */
      .dark-info-box-print {
        background-color: #f5f5f5 !important;
        color: #000000 !important;
        border: 1px solid #ddd !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      
      .dark-info-box-print .MuiTypography-caption {
        color: #666666 !important;
      }
      
      .dark-info-box-print .MuiTypography-body1 {
        color: #000000 !important;
      }
      
      /* Force other elements to show colors in print */
      .MuiTableHead-root {
        background-color: #1976d2 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      
      .MuiTableCell-head {
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      
      .total-row-print {
        background-color: #f5f5f5 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      
      .invoice-number-box-print {
        background-color: #1976d2 !important;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      
      @page {
        size: A4;
        margin: 15mm;
      }
    }
  `;

    document.head.appendChild(printStyles);
    window.print();

    setTimeout(() => {
      document.head.removeChild(printStyles);
      noPrintElements.forEach(element => {
        element.style.display = '';
      });
    }, 100);
  };

  const downloadInvoice = () => {
    const element = document.getElementById("invoice-content");
    const opt = {
      margin: [10, 10, 10, 10],
      filename: `invoice_${patientId}_${serial_no}.pdf`,
      image: {
        type: "jpeg",
        quality: 0.98
      },
      html2canvas: {
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        ignoreElements: function (element) {
          return element.classList.contains('no-print');
        }
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        floatPrecision: 16
      },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    const tempStyles = document.createElement('style');
    tempStyles.innerHTML = `
      .invoice-number-pdf {
        backgroundColor: theme.palette.secondary.main;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    `;
    document.head.appendChild(tempStyles);

    html2pdf().set(opt).from(element).save().then(() => {
      document.head.removeChild(tempStyles);
    });
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
          <Typography variant="h6" color="error">
            {error}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }} className="no-print">
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          variant="outlined"
        >
          Back to Records
        </Button>
      </Box>

      <StyledPaper elevation={3} id="invoice-content">
        <HeaderBox>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              src={logo}
              alt="Medicare Logo"
              variant="rounded"
              sx={{ width: 80, height: 80, '@media print': { width: 60, height: 60 } }}
            />
            <Box>
              <Typography variant="h5" fontWeight="bold" color="primary" sx={{ '@media print': { fontSize: '2rem' } }}>
                BEAUTY BLISS
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
                202/A, Mandawala Road,Malamulla,Panadura.
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
                Tel: 076 380 9974
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
                Web: www.beautyblissbyprima.com
              </Typography>
            </Box>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Typography  color="primary"  sx={{ '@media print': { fontSize: '0.9rem' } }}>
              Payment Receipt
            </Typography>
            <InvoiceNumberBox className="invoice-number-pdf invoice-number-box-print">
              Invoice - {invoicedetails?.MTD_SERIAL_NO || "N/A"}
            </InvoiceNumberBox>
          </Box>
        </HeaderBox>

        <Divider sx={{ my: 3 }} />

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 2, sm: 3 },
            mb: 4,
            alignItems: "center",
            justifyContent: "space-between",
            '@media (max-width: 600px)': {
              flexDirection: 'column',
            },
            '@media print': {
              gap: 2,
              marginBottom: '16px',
            }
          }}
        >
          <DarkInfoBox className="dark-info-box-print">
            <Typography variant="caption">
              Customer Name
            </Typography>
            <Typography variant="body1">
              tesr
            </Typography>
          </DarkInfoBox>

          <DarkInfoBox className="dark-info-box-print">
            <Typography variant="caption">
              Address
            </Typography>
            <Typography variant="body1">
              Colombo 14
            </Typography>
          </DarkInfoBox>

          <DarkInfoBox className="dark-info-box-print">
            <Typography variant="caption">
              Date
            </Typography>
            <Typography variant="body1">
              12/8/2025
            </Typography>
          </DarkInfoBox>

          <DarkInfoBox className="dark-info-box-print">
            <Typography variant="caption">
              Gender / Age
            </Typography>
            <Typography variant="body1">
              Male / 4
            </Typography>
          </DarkInfoBox>
        </Box>

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ border: "1px solid #eee", mb: 4 }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: "primary.main" }}>
              <TableRow>
                <TableCell sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}>
                 Products and Treatments
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Rate (Rs)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Quantity
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Amount (Rs)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoicedetails?.Drugs?.map((medicinedetail, index) => (
                <TableRow key={index} hover>
                  <TableCell sx={{ '@media print': { fontSize: '0.9rem' } }}>{medicinedetail.DrugName}</TableCell>
                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_RATE
                      ? new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(Number(medicinedetail.MDD_RATE))
                      : "0.00"}
                  </TableCell>

                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_QUANTITY
                      ? new Intl.NumberFormat('en-US').format(Number(medicinedetail.MDD_QUANTITY))
                      : "0"}
                  </TableCell>

                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_AMOUNT
                      ? new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(Number(medicinedetail.MDD_AMOUNT))
                      : "0.00"}
                  </TableCell>
                </TableRow>
              ))}

              <TotalRow className="total-row-print">
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ 
                  '@media print': { fontSize: '0.9rem' },
                  fontSize: '0.9rem'  // Smaller font size for Total Treatment Fee
                }}>
                  Total Treatment Fee:
                </TableCell>
                <TableCell align="right" sx={{ 
                  '@media print': { fontSize: '1rem' },
                  fontSize: '0.9rem'  // Smaller font size for amount
                }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(Number(calculateSubtotal()))}
                </TableCell>
              </TotalRow>

              <TotalRow className="total-row-print">
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ 
                  '@media print': { fontSize: '0.9rem' },
                  fontSize: '0.9rem'  // Smaller font size for Treatment Fee
                }}>
                  Treatment Fee:
                </TableCell>
                <TableCell align="right" sx={{ 
                  '@media print': { fontSize: '1rem' },
                  fontSize: '0.9rem'  // Smaller font size for amount
                }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(Number(treatmentamount))}
                </TableCell>
              </TotalRow>

              <TotalRow className="total-row-print">
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ 
                  '@media print': { fontSize: '0.9rem' },
                  fontSize: '0.9rem'  // Smaller font size for Subtotal
                }}>
                  Subtotal:
                </TableCell>
                <TableCell align="right" sx={{ 
                  '@media print': { fontSize: '1rem' },
                  fontSize: '0.9rem'  // Smaller font size for amount
                }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(
                    Number(calculateSubtotal()) + Number(treatmentamount)
                  )}
                </TableCell>
              </TotalRow>

              <DiscountRow>
                <TableCell colSpan={1}></TableCell>
                <TableCell>
                  <Typography fontWeight="bold" sx={{ '@media print': { fontSize: '0.9rem' } }}>Discount</Typography>
                  <RadioGroup
                    row
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    sx={{ mt: 1 }}
                  >
                    <FormControlLabel
                      value="percentage"
                      control={<Radio size="small" />}
                      label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Percentage</Typography>}
                    />
                    <FormControlLabel
                      value="fixed"
                      control={<Radio size="small" />}
                      label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Fixed Amount</Typography>}
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell align="right">
                  <TextField
                    type="number"
                    size="small"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                    inputProps={{
                      min: "0",
                      max:
                        discountType === "percentage"
                          ? "100"
                          : parseFloat(calculateSubtotal()) +
                          parseFloat(treatmentamount),
                    }}
                    sx={{ width: 120 }}
                  />
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  {discountType === "percentage"
                    ? `${discount}%`
                    : `Rs: ${discount}`}
                </TableCell>
              </DiscountRow>

              <TotalRow sx={{ backgroundColor: "primary.light" }}>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ color: "common.white", '@media print': { fontSize: '0.9rem' } }}>
                  <Typography variant="h6">Final Amount:</Typography>
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", '@media print': { fontSize: '0.9rem' } }}
                >
                  <Typography variant="h6">
                    Rs: {new Intl.NumberFormat('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }).format(Number(calculateTotalAmount()))}
                  </Typography>
                </TableCell>
              </TotalRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          sx={{
            mt: 6,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <Box
            sx={{
              width: 300,
              textAlign: "center",
              p: 2,
            }}
          >
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" color="text.secondary" sx={{ '@media print': { fontSize: '0.9rem' } }}>
              Authorized Signature
            </Typography>
            <Typography variant="h6" fontWeight="bold" sx={{ mt: 1, '@media print': { fontSize: '0.9rem' } }}>
             Beauty Bliss
            </Typography>
          </Box>
        </Box>
      </StyledPaper>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          mt: 4,
          "@media print": {
            display: "none",
          },
        }}
        className="no-print"
      >
        <Tooltip title="Print standard invoice">
          <Button
            variant="contained"
            color="primary"
            startIcon={<Print />}
            onClick={printInvoice}
            sx={{ px: 4, py: 1.5 }}
          >
            Print Invoice
          </Button>
        </Tooltip>
         <Tooltip title="Send Invoice via SMS">
            <Button
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
              onClick={sendSmsBill}
              sx={{ px: 4, py: 1.5 }}
              disabled={smsLoading}
            >
              {smsLoading ? "Sending..." : "SMS Bill"}
            </Button>
          </Tooltip>

        <Tooltip title="Print thermal receipt via QZ Tray">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<ReceiptLong />}
            onClick={() => setQzTrayDialogOpen(true)}
            sx={{ px: 4, py: 1.5 }}
          >
            QZ Tray Print
          </Button>
        </Tooltip>

        <Tooltip title="Download as PDF">
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Download />}
            onClick={downloadInvoice}
            sx={{ px: 4, py: 1.5 }}
          >
            Download PDF
          </Button>
        </Tooltip>
      </Box>

    <Snackbar
      open={smsStatus.open}
      autoHideDuration={6000}
      onClose={() => setSmsStatus({ ...smsStatus, open: false })}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity={smsStatus.severity}
        onClose={() => setSmsStatus({ ...smsStatus, open: false })}
        sx={{ width: "100%" }}
      >
        {smsStatus.message}
      </Alert>
    </Snackbar>

      {/* QZ Tray Thermal Printing Dialog */}
      <QZTrayThermalPrint
        open={qzTrayDialogOpen}
        onClose={() => setQzTrayDialogOpen(false)}
        patients={patients}
        invoicedetails={invoicedetails}
        treatmentamount={treatmentamount}
        discount={discount}
        discountType={discountType}
        calculateSubtotal={calculateSubtotal}
        calculateTotalAmount={calculateTotalAmount}
      />
    </Container>
  );
}